import { NgTemplateOutlet, NgClass, CurrencyPipe, ViewportScroller, Location, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterOutlet, RouterLink } from '@angular/router';
import { NgbModal, NgbOffcanvasRef } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { environment } from '../../_environments/environment';
import { Box } from '../../_model/box';
import { Flowtype, Orderline } from '../../_model/order';
import { Product } from '../../_model/product';
import { Entitytype } from '../../_model/redirect';
import { TaxonomyNode } from '../../_model/taxonomy';
import { DrawerService, Drawerposition } from '../../_service/DrawerService';
import { GlobalService } from '../../_service/GlobalService';
import { OrderService } from '../../_service/OrderService';
import { RedirectService } from '../../_service/RedirectService';
import { TaxonomyService } from '../../_service/TaxonomyService';
import { ProductService } from '../../_service/ProductService';
import { BoxService } from '../../_service/BoxService';
import { Countrycode } from '../../_model/shared';
import { TranslateModule } from '@ngx-translate/core';
import { PricetotalComponent } from '../../sharedModule/pricetotal/pricetotal.component';
import { EmptylineComponent } from '../../sharedModule/orderline/emptyline/emptyline.component';
import { BoxlineComponent } from '../../sharedModule/orderline/boxline/boxline.component';
import { ProductlineComponent } from '../../sharedModule/orderline/productline/productline.component';
import { BoxComponent } from '../../sharedModule/orderline/box/box.component';
import { ProductComponent } from '../../sharedModule/orderline/product/product.component';
import { BoxcardComponent } from '../../sharedModule/orderline/boxcard/boxcard.component';
import { ProductcardComponent } from '../../sharedModule/orderline/productcard/productcard.component';
import { TaxonomynodeComponent } from '../../sharedModule/taxonomynode/taxonomynode.component';
import { LinkService } from '../../_service/LinkService';
import { OverlayComponent } from 'src/orderflowModule/overlay/overlay.component';
import { WINDOW } from 'src/_service/WindowService';


@Component({
  selector: 'app-webshop',
  templateUrl: './webshop.component.html',
  styleUrls: ['./webshop.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule, TranslateModule,
    NgTemplateOutlet, RouterOutlet, NgClass, RouterLink, CurrencyPipe, 
    TaxonomynodeComponent, ProductcardComponent, BoxcardComponent,  ProductlineComponent, BoxlineComponent, EmptylineComponent, PricetotalComponent]
})
export class WebshopComponent implements OnInit, OnDestroy {

  _env = environment;

  dateNextWeek = this._orderService.assumedDeliverydate;

  orderlines: FormArray;
  order: FormGroup;
  taxonomyNode: TaxonomyNode;
  overlaycomponent: OverlayComponent

  ordersideNavOpened = false;

  error_taxonomy = false;

  @ViewChild('sidedrawercontent', { static: true }) public sidedrawercontent;

  currentUrl: string;

  offCanvas: NgbOffcanvasRef;
  offCanvasOpen = false;

  detailsDrawer: NgbOffcanvasRef;
  detailsdrawerOpen = false;

  private unsubscribe = new Subject<void>();
  orderRecipeCount$ = new BehaviorSubject<number>(0);


  constructor(
    public activatedRoute: ActivatedRoute,
    private _router: Router,

    private _orderService: OrderService,
    private _taxonomyService: TaxonomyService,
    private _redirectService: RedirectService,
    private _globalService: GlobalService,

    private _productService: ProductService,
    private _boxService: BoxService,
    private _linkService: LinkService,

    public drawerService: DrawerService,
    private _viewportScroller: ViewportScroller,
    private _location: Location,
    private _modalService: NgbModal,
    @Inject(WINDOW) private window: Window,
    @Inject(PLATFORM_ID) private platformId: any,
  ) {

  }

  get countrycode(): Countrycode {
    return this._orderService.countrycode.value
  }

  ngOnInit() {

    this._linkService.setStaticpageSeoData('singleorder.metatitle', 'singleorder.metadescription', '/assets/images/ekomenu_webshop.webp', 'singleorder.organicwebshop_url')

    this.drawerService.setDrawer(Drawerposition.end, this.sidedrawercontent, 'webshop-drawer');

    this.orderlines = this._orderService.orderlines;
    this.order = this._orderService.order;
    this.orderRecipeCount$ = this._orderService.singleorderRecipeCount;

    this.activatedRoute.queryParams.pipe(takeUntil(this.unsubscribe)).subscribe(queryParams => {
      if (!queryParams.product && !queryParams.box && this.overlaycomponent) {
        this.overlaycomponent.closeOverlay();
      } else {
        setTimeout(() => {
          this.getCurrentUrlState();
        });
      }
    })

    this._globalService.addToDatalayer('virtualPageLoaded')
  }

  ngAfterViewInit() {
    this.getCurrentUrlState();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();

    if(this.overlaycomponent && this.overlaycomponent.closeOverlay)
      this.overlaycomponent.closeOverlay()

    this._linkService.removeLinkTag('rel="alternate"')
    this._linkService.removeLinkTag('rel="canonical"')
    this._linkService.removeMetaData();
  }

  getCurrentUrlState() {

    const params = this.activatedRoute.snapshot.queryParams;

    if (!params.webshop) {
      this._taxonomyService.getTaxonomy(environment.webshoptaxonomyid).subscribe(next => {
        this._taxonomyService.getTaxonomynode(next.entrynode).subscribe(
          next => {
            //makes sure that the urlparam is only applied when in the webshop
            if (this.activatedRoute.children.length == 0)
              this._router.navigate(
                [],
                {
                  relativeTo: this.activatedRoute,
                  queryParams: { webshop: next.id },
                  queryParamsHandling: 'merge', // remove to replace all query params by provided
                });

            this._redirectService.getEntityUrl(Entitytype.TAXONOMY, next.id, next.redirectid).then(value => next['taxonomyurl'] = value);
            this.taxonomyNode = next;

          }, error => {
            this.error_taxonomy = true;
          }
        );

      })
    }

    // use this ID i.s.o the SEO urls please
    if (params.product) {
      if (this.overlaycomponent) return;
      //makes sure the overlaycomponent is not null, so it wont open twice
      this.overlaycomponent = {} as OverlayComponent
      this._productService.getProduct(params.product).subscribe(result => {
        this.showProduct(result)
      });
    }

    if (params.box) {
      if (this.overlaycomponent) return;
      //makes sure the overlaycomponent is not null, so it wont open twice
      this.overlaycomponent = {} as OverlayComponent
      this._boxService.getBox(params.box).subscribe(result => {
        this.showBox(result)
      });
    }

  }

  updateRouteParams(object: any, updateView = false, updateActivatedRoute = false) {
    if (updateView) {
      const currentScrollPosition = this._viewportScroller.getScrollPosition();
      this._router.navigate(
        [],
        {
          relativeTo: this.activatedRoute,
          queryParams: object,
          queryParamsHandling: 'merge', // remove to replace all query params by provided
        }).then(() => {
          setTimeout(() => {
            this._viewportScroller.scrollToPosition(currentScrollPosition); // Restore scroll after routing
          });

        });
    } else {
      //makes sure that the view istn updated and the page isnt scrolled up
      const queryparams = { ...this.activatedRoute.snapshot.queryParams, ...object }
      const querystring = JSON.stringify(queryparams, (k, v) => {
        Object.keys(v).forEach(key => {
          if (!v[key]) return
          k = `${k ? k + '&' : k}${key}=${v[key]}`
        })
        return k
      })
      if(isPlatformBrowser(this.platformId))
        this._location.go(this.window.location.pathname, querystring.replaceAll('"', ""),)
    }
  }


  toggleDrawer() {
    if (!this.offCanvasOpen) {
      this.offCanvasOpen = true;
      this.offCanvas = this.drawerService.toggle('webshop-drawer');
      this.offCanvas.dismissed.pipe(takeUntil(this.unsubscribe)).subscribe(() => {
        this.offCanvasOpen = false;
      })
    } else {
      this.offCanvasOpen = false;
      this.offCanvas.dismiss();
    }
  }

  showProduct(product: Product) {
    if(isPlatformServer(this.platformId)) return;
    this.updateRouteParams({ product: product.id })

    const dialog = this._modalService.open(OverlayComponent, { modalDialogClass: 'w-[97%] max-w-7xl h-[95%] rounded-lg' });
    this.overlaycomponent = dialog.componentInstance;
    this.overlaycomponent.modal = dialog;
    this.overlaycomponent.innerComponent = ProductComponent

    this.overlaycomponent.createdComponent.pipe(takeUntil(this.unsubscribe)).subscribe((res: ProductComponent) => {
      res.product = product;
      res.orderlines = this.orderlines.value;
      res.addOrderline.pipe(takeUntil(this.overlaycomponent.modal.closed)).subscribe(res => this.addOrderline(res, product, null))
      res.quantityChange.pipe(takeUntil(this.overlaycomponent.modal.closed)).subscribe(res => this.changeProductSelectionQty(null, res, product))

    })
    dialog.closed.subscribe(() => {
      this.updateRouteParams({ product: null })
      this.overlaycomponent = null;
    })
    dialog.dismissed.subscribe(() => {
      this.updateRouteParams({ product: null })
      this.overlaycomponent = null;
    })
  }
  showBox(box: Box) {
    if(isPlatformServer(this.platformId)) return;
    this.updateRouteParams({ box: box.id })

    const dialog = this._modalService.open(OverlayComponent, { modalDialogClass: 'w-[97%] max-w-7xl h-[95%] rounded-lg' });
    this.overlaycomponent = dialog.componentInstance;
    this.overlaycomponent.modal = dialog;
    this.overlaycomponent.innerComponent = BoxComponent

    this.overlaycomponent.createdComponent.pipe(takeUntil(this.unsubscribe)).subscribe((res: BoxComponent) => {
      res.box = box;
      res.orderlines = this.orderlines.value;
      this.overlaycomponent.modal.closed.subscribe(res=>{console.log('modal closed!')})
      res.addOrderline.pipe(takeUntil(this.overlaycomponent.modal.closed)).subscribe(res => this.addOrderline(res, null, box))
      res.quantityChange.pipe(takeUntil(this.overlaycomponent.modal.closed)).subscribe(res => this.changeProductSelectionQty(null, res, null, box))
      res.personsChange.pipe(takeUntil(this.overlaycomponent.modal.closed)).subscribe(res => this.changeBoxPersonQty(null, res, box))
    })

    dialog.closed.subscribe(() => {
      this.updateRouteParams({ box: null })
      this.overlaycomponent = null;
    })
    dialog.dismissed.subscribe(() => {
      this.updateRouteParams({ box: null })
      this.overlaycomponent = null;
    })
  }
  getMethods(obj) {
    const methods = [];
    do {
      for (const prop of Object.getOwnPropertyNames(obj)) {
        if (obj[prop] instanceof Function) methods.push(prop);
      }
      obj = Object.getPrototypeOf(obj);
    } while (obj !== null)
  
    return methods;
  }

  addOrderline(orderline: Orderline, product: Product = null, box: Box = null) {
    this._orderService.createNewOrderline(product, box, null, orderline.persons, orderline.quantity, false, false, true, orderline.onetimebox, Flowtype.SINGLEORDER)
  }
  changeProductSelectionQty(index: number = null, value: number, product: Product = null, box: Box = null) {
    const min = 1;

    if (value < min) {
      if (!index)
        index = this._orderService.getOrderlineIndex(product, box, null, false, Flowtype.SINGLEORDER)
      this._orderService.removeOrderlineByIndex(index);
      return;
    }

    if (index) {
      this._orderService.changeOrderlineByIndex(index, Flowtype.SINGLEORDER, null, value)
    } else {
      this._orderService.changeOrderlineByContent(product, box, null, Flowtype.SINGLEORDER, null, value, false)
    }
  }
  changeBoxPersonQty(index: number = null, value: number, box: Box = null) {

    if (index !== null) {
      this._orderService.changeOrderlineByIndex(index, Flowtype.SINGLEORDER, value, null)
    } else {
      this._orderService.changeOrderlineByContent(null, box, null, Flowtype.SINGLEORDER, value, null, false)
    }

  }
}